module.exports = __webpack_public_path__ + "static/logo-6eb270df06f0cca0a217c7508345b5b8.png";